import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ModeratorService } from 'src/app/shared/moderator/moderator.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-verify-conversation',
    templateUrl: './verify-conversation.component.html',
    styleUrls: ['./verify-conversation.component.css'],
    standalone: false
})
export class VerifyConversationComponent implements OnInit {
  role
  unverifiedMessages: any
  tickets: any[] = []
  serverErrorMessages: string;
  loading: boolean = true
  messages: any[] = [];
  closeResult: string;
  verifyMessageIds: any[] = [];
  deleteMessageIds: any[] = [];
  ticketID
  newMessage = new FormControl('')
  constructor(private loginService: LoginService, private moderatorService: ModeratorService, private router : Router, private modalService: NgbModal, private datePipe: DatePipe) {
    this.getAllUnverifiedMessages();

   }

   ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
        }
      )
    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  onLogout(){
    this.loginService.deleteToken();
    this.router.navigateByUrl('/signin');
  }

  getAllUnverifiedMessages(){
    this.moderatorService.getAllUnverifiedMessages().subscribe(
      res => {
        ////console.log('got unverified ticket IDs', res)
        this.unverifiedMessages = res['tickets']
       //console.log(this.unverifiedMessages)
        var v = new Promise<void>((resolve, reject) =>{
          this.unverifiedMessages.forEach(element => {
            this.getTicketDetails(element['_id'])
          });
          resolve();
        });
       //console.log(this.tickets)
      },
      err => {
       //console.log('error', err)
      }
    )
  }

  getTicketDetails(ticketID){
    this.moderatorService.getTicketDetails({ticketId: ticketID}).subscribe(
      res => {
        ////console.log('got ticket details', res)
        this.tickets.push(res['ticket'])
      },
      err => {
       //console.log('error', err)
      }
    )
  }
  open(content, messages, ticketID) {
    ////console.log(content, typeof(content))
    this.ticketID = ticketID;
    this.messages = messages;
   //console.log(messages)
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.verifyMessageIds = []
      this.deleteMessageIds = []
     //console.log('array cleared', this.verifyMessageIds, this.deleteMessageIds)
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  addToVerifyMessageIds(id){
    this.verifyMessageIds.push(id)
   //console.log(this.verifyMessageIds)
  }

  addToDeleteMessageIds(id){
    this.deleteMessageIds.push(id)
   //console.log(this.deleteMessageIds)
  }

  verifyMessages(){
    this.moderatorService.verifyMessage({ticketId:this.ticketID, messageIds: this.verifyMessageIds, verificationStatus: true}).subscribe(
      res => {
       //console.log('verified', res)
        window.location.reload()
      },
      err => {
       //console.log('error', err)
      }
    )
  }

  deleteMessages(){
    this.moderatorService.deleteMessage({ticketId:this.ticketID, messageIds: this.deleteMessageIds}).subscribe(
      res => {
       //console.log('deleted', res)
        window.location.reload()
      },
      err => {
       //console.log('error', err)
      }
    )
  }

  editMessage(messageID){
   //console.log(this.ticketID, messageID, this.newMessage.value)
    this.moderatorService.editMessage({ticketId: this.ticketID, messageId: messageID, newMessage: this.newMessage.value}).subscribe(
      res => {
       //console.log('edited', res)
      },
      err => {
       //console.log('error', err)
      }
    )
  }

  transformDate(x){
    return(this.datePipe.transform(x, 'yyyy-MM-dd'));
  }

}
